module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/commons/templates/HolidaysRow.ejs -->\n';
 if (!model.get('companyId')) { 
__p+='\n    <td class="td-nowrap date-readonly">\n        <div class="m-t-sm m-b-sm">\n            '+
((__t=( model.getFormatted('date', 'DD/MM/YYYY') ))==null?'':_.escape(__t))+
'\n        </div>\n    </td>\n    <td>\n        <div class="m-l-sm m-t-sm m-b-sm">\n            '+
((__t=( model.get('title') ))==null?'':_.escape(__t))+
'\n        </div>\n    </td>\n    <td class="form-group">\n        <label class="ichecks">\n            <input type="checkbox" value="1" name="enabled"\n                data-value-type="boolean"\n                class="js-icheck js-ext js-ext-toggle"\n                '+
((__t=( model.isEnabled() ? 'checked' : '' ))==null?'':_.escape(__t))+
'>\n            <i></i>\n        </label>\n    </td>\n';
 } 
__p+='\n';
 if (model.get('companyId')) { 
__p+='\n    <td class="td-nowrap">\n        <span class="date js-datepicker input-group input-group-invisible"\n            data-date-format="dd/mm/yyyy">\n            <span class="input-group-addon">\n                <span class="glyphicon glyphicon-calendar"></span>\n            </span>\n            <input type="text" class="form-control\n                js-datepicker-input"\n                name="date"\n                value="'+
((__t=( model.getFormatted('date', 'DD/MM/YYYY') ))==null?'':_.escape(__t))+
'">\n        </span>\n    </td>\n    <td>\n        <div class="form-control form-control-with-delete">\n            <span class="form-control-value"></span>\n            <input name="title"\n                class="form-control form-control-invisible"\n                type="text" autocomplete="off"\n                value="'+
((__t=( model.get('title') ))==null?'':_.escape(__t))+
'">\n            <a class="form-control-delete fa fa-times btn-delete js-destroy"\n                tabindex="-1"></a>\n        </div>\n    </td>\n    <td class="form-group">\n    </td>\n';
 } 
__p+='\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/commons/templates/HolidaysRow.ejs
// module id = 859
// module chunks = 1